import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import moment from "moment"

import {Query} from "../"
import {commentFiltersToString} from "../../helpers/filtersToString"

export const query = gql`
  query InsightsCommentTagCount($params: InsightsCommentTagCountInput!) {
      insightsCommentTagCount(params: $params) {
        results {
          value
          count
        }
        count
        total
      }
    }
`


const GetCommentTagCountQuery = ({children, filters, tenant, cycle: {id: cycleId}, tagType, tagValue, ...props}) => {
  const {time} = filters
  const minCreatedAt = time ? moment(time).utc().format() : null
  const filter = commentFiltersToString({...filters, cycleId})
  const params = {tenant, filter, minCreatedAt, tagType, tagValue}
  return (
    <Query
      {...props}
      variables={{params}}
      query={query}>
      {({data: {insightsCommentTagCount: tagCount = {}}, ...apolloState}) => {
        return children({tagCount, ...apolloState})
      }}
    </Query>
  )
}

GetCommentTagCountQuery.propTypes = {
  children: PropTypes.func.isRequired,
  filters: PropTypes.object,
  tenant: PropTypes.string.isRequired,
  cycle: PropTypes.object.isRequired,
  tagType: PropTypes.string.isRequired,
  tagValue: PropTypes.string.isRequired
}

GetCommentTagCountQuery.defaultProps = {
  filters: {}
}


export default GetCommentTagCountQuery
